import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import Utils from "../../utils/utils";
import ImageInput from "../../widgets/ImageInput";
import addEvento from "../../services/addEvento";
import ImageSilentInput from "../../widgets/ImageSilentInput";
import MyDatePicker from "../../widgets/DatePicker";
import moment from "moment";
import TimeInput from "../../widgets/TimeInput";
// Editor WYSIWYG per formattazione HTML
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "../../widgets/css/editor.css";

export default class AddEvento extends React.Component {
  constructor(props) {
    super(props);

    this.startDateRef = React.createRef();

    this.state = {
      titolo: "",
      link1: "",
      link2: "",
      titolo_l1: "",
      titolo_l2: "",
      desc: "",
      attachment: null,
      attachmentFileName: "",
      locandina: "",
      orario: "",
      orarioFine: "",
      partecipanti: 0,
      isMobile: window.innerWidth < 768,
      editorState: EditorState.createEmpty(),
      uploadProgress: 0, // Progress bar per upload
      isUploading: false, // Flag per indicare upload in corso
    };
    this.pageTitle = "Crea nuovo evento";
  }

  componentDidMount() {
    window.addEventListener("resize", () => this.manageResize());
    this.setState({});
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.manageResize());
  }

  manageResize() {
    if (window.innerWidth >= 768) {
      this.setState({ isMobile: false });
    } else {
      this.setState({ isMobile: true });
    }
  }

  lockedSaveEvento = Utils.disallowConcurrency(this.save.bind(this));

  render() {
    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              ...base,
              width: "100%",
              position: "relative",
              paddingTop: "20px",
              paddingBottom: "20px",
            }),
          }}
          spinner
          text={
            this.state.isUploading
              ? `Caricamento evento... ${this.state.uploadProgress}%`
              : "Loading your content..."
          }
        >
          {/* Progress bar durante upload */}
          {this.state.isUploading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                padding: "20px",
              }}
            >
              <div
                style={{ maxWidth: "600px", margin: "0 auto", color: "white" }}
              >
                <div style={{ marginBottom: "10px", fontSize: "16px" }}>
                  {this.state.uploadProgress < 95 && "📤 Caricamento evento..."}
                  {this.state.uploadProgress >= 95 &&
                    this.state.uploadProgress < 100 &&
                    "⏳ Elaborazione..."}
                  {this.state.uploadProgress === 100 && "✅ Completato!"}
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "30px",
                    backgroundColor: "#333",
                    borderRadius: "15px",
                    overflow: "hidden",
                    border: "2px solid #555",
                  }}
                >
                  <div
                    style={{
                      width: `${this.state.uploadProgress}%`,
                      height: "100%",
                      backgroundColor:
                        this.state.uploadProgress === 100
                          ? "#4caf50"
                          : "#c41e3a",
                      transition: "width 0.3s ease, background-color 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                    >
                      {this.state.uploadProgress}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <PageTitle title={this.pageTitle} />

          <div
            style={{
              display: "flex",
              flexDirection: this.state.isMobile ? "column" : "row",
            }}
          >
            {/* Sezione sinistra con informazioni generali */}
            <div
              style={{
                flex: 1,
                marginRight: this.state.isMobile ? "0" : "20px",
              }}
            >
              <h3 style={{ marginBottom: 10 }}>Informazioni generali</h3>
              <p style={{ opacity: 0.7, marginBottom: 20 }}>
                Aggiungi titolo, descrizione e immagine di copertina per
                l'evento.
                <br />
                Preferibilmente un'immagine orizzontale.
              </p>

              <ImageInput
                name="Copertina"
                value={this.state.locandina}
                onChange={(base64) => {
                  this.setState({ locandina: base64 });
                }}
              />

              <TextInput
                name="Titolo"
                value={this.state.titolo}
                onChange={(text) => {
                  this.setState({ titolo: text });
                }}
              />

              <MyDatePicker ref={this.startDateRef} name="Data" value={null} />

              <TimeInput
                autoFocus
                readOnly={false}
                time
                name={"Orario inizio"}
                value={this.state.orario}
                onChange={(val) => this.setState({ orario: val })}
              />

              <TimeInput
                autoFocus
                readOnly={false}
                time
                name={"Orario fine"}
                value={this.state.orarioFine}
                onChange={(val) => this.setState({ orarioFine: val })}
              />

              <TextInput
                name="Numero partecipanti"
                type="number"
                value={this.state.partecipanti}
                onChange={(num) => {
                  this.setState({ partecipanti: num });
                }}
              />

              <div style={{ marginTop: 20 }}>
                <label style={{ marginBottom: 10, display: "block" }}>
                  Descrizione dell'evento
                </label>
                <Editor
                  editorState={this.state.editorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  onEditorStateChange={(editorState) => {
                    this.setState({
                      editorState,
                      desc: draftToHtml(
                        convertToRaw(editorState.getCurrentContent())
                      ),
                    });
                  }}
                  toolbar={{
                    options: [
                      "inline",
                      "blockType",
                      "fontSize",
                      "list",
                      "textAlign",
                      "colorPicker",
                      "link",
                      "emoji",
                      "history",
                    ],
                    inline: {
                      options: [
                        "bold",
                        "italic",
                        "underline",
                        "strikethrough",
                        "monospace",
                      ],
                    },
                  }}
                  localization={{
                    locale: "it",
                  }}
                />
              </div>
            </div>

            {/* Sezione destra con allegato e link */}
            <div
              style={{
                flex: 1,
                marginLeft: this.state.isMobile ? "0" : "20px",
              }}
            >
              <h3 style={{ marginBottom: 10 }}>Allegato e Link</h3>
              <p style={{ opacity: 0.7, marginBottom: 20 }}>
                Aggiungi un documento allegato e link aggiuntivi per l'evento.
              </p>

              <ImageSilentInput
                name={
                  this.state.attachmentFileName
                    ? this.state.attachmentFileName
                    : "Aggiungi documento"
                }
                fileName={this.state.attachmentFileName}
                key={Math.random()}
                value={this.state.attachment}
                onChange={async (base64, fileName, fileInfo) => {
                  this.setState({
                    attachment: base64,
                    attachmentFileName: fileName,
                  });
                }}
              />

              <TextInput
                name="Link 1"
                value={this.state.link1}
                onChange={(text) => {
                  this.setState({ link1: text });
                }}
              />

              <TextInput
                name="Titolo link 1"
                value={this.state.titolo_l1}
                onChange={(text) => {
                  this.setState({ titolo_l1: text });
                }}
              />

              <TextInput
                name="Link 2"
                value={this.state.link2}
                onChange={(text) => {
                  this.setState({ link2: text });
                }}
              />

              <TextInput
                name="Titolo link 2"
                value={this.state.titolo_l2}
                onChange={(text) => {
                  this.setState({ titolo_l2: text });
                }}
              />
            </div>
          </div>

          <br />

          <FixButton
            title="Salva"
            callback={this.state.isLoading ? () => {} : this.lockedSaveEvento}
          />
        </LoadingOverlay>
      </>
    );
  }

  isValidUrl(urlString) {
    var urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // validate fragment locator
    return !!urlPattern.test(urlString);
  }

  async save() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const userId = cookies.get("userId", { path: "/" });

    if (!this.state.titolo.trim()) {
      alert("Inserire almeno un titolo per l'evento");
      return;
    }

    if (!this.state.desc.trim()) {
      alert("Inserire almeno una descrizione per l'evento");
      return;
    }

    if (this.state.link1 && !this.isValidUrl(this.state.link1)) {
      alert("Link 1 non sembra essere un indirizzo valido.");
      return;
    }

    if (this.state.link2 && !this.isValidUrl(this.state.link2)) {
      alert("Link 2 non sembra essere un indirizzo valido.");
      return;
    }

    if (this.state.partecipanti <= 0) {
      alert("Il numero di partecipanti deve essere maggiore di 0");
      return;
    }

    if (!this.state.orario || !this.state.orarioFine) {
      alert("Inserire un orario di inizio e fine per l'evento");
      return;
    }

    if (this.state.orario >= this.state.orarioFine) {
      alert("L'orario di fine deve essere successivo a quello di inizio");
      return;
    }

    if (
      (this.state.link1 && !this.state.titolo_l1.trim()) ||
      (this.state.link2 && !this.state.titolo_l2.trim())
    ) {
      if (
        !window.confirm(
          "Uno o più link non hanno un titolo impostato. Nell'applicazione i pulsanti verranno mostrati con testi di default (ad es: APRI LINK). Vuoi procedere comunque?"
        )
      ) {
        return;
      }
    }

    const hasAttachment = !!this.state.attachment;

    // Mostra la progress bar solo se c'è un allegato da caricare
    this.setState({
      isLoading: true,
      isUploading: hasAttachment,
      uploadProgress: 0,
    });

    const xStartDate = this.startDateRef.current.getDate();
    let date = xStartDate ? moment(xStartDate).format("DD/MM/yyyy") : "";

    let evento = {
      titolo: this.state.titolo,
      descrizione: this.state.desc,
      link1: this.state.link1,
      link2: this.state.link2,
      titolo_l1: this.state.titolo_l1,
      titolo_l2: this.state.titolo_l2,
      locandina: this.state.locandina,
      allegato: hasAttachment ? this.state.attachment : null,
      allegato_nome: hasAttachment
        ? this.state.attachmentFileName || null
        : null,
      data: date,
      partecipanti: this.state.partecipanti,
      orario: this.state.orario,
      orarioFine: this.state.orarioFine,
    };

    try {
      let ret = await addEvento(username, token, evento, userId, (progress) => {
        console.log(`[AddEvento] Upload progress: ${progress}%`);
        this.setState({ uploadProgress: progress });
      });

      if (ret.result == "ok") {
        cookies.set("currentEvent", ret.id, { path: "/" });
        this.setState({
          isLoading: false,
          isUploading: false,
          uploadProgress: 100,
        });
        window.location.href = "/#/app/eventi";
      } else {
        this.setState({
          isLoading: false,
          isUploading: false,
          uploadProgress: 0,
        });
        alert(
          "Si è verificato un errore inatteso durante la creazione dell'evento. Per favore, riprova."
        );
      }
    } catch (error) {
      console.error("[AddEvento] Errore durante creazione evento:", error);
      this.setState({
        isLoading: false,
        isUploading: false,
        uploadProgress: 0,
      });
      alert(
        error.message ||
          "Errore durante la creazione dell'evento. Riprova più tardi."
      );
    }
  }
}
